__turbopack_context__.v({
  "parent_link": "SearchWebThumbnail-module-scss-module__DsYWya__parent_link",
  "search_web_thumbnail": "SearchWebThumbnail-module-scss-module__DsYWya__search_web_thumbnail",
  "search_web_thumbnail__container": "SearchWebThumbnail-module-scss-module__DsYWya__search_web_thumbnail__container",
  "search_web_thumbnail__description": "SearchWebThumbnail-module-scss-module__DsYWya__search_web_thumbnail__description",
  "search_web_thumbnail__fallback_link": "SearchWebThumbnail-module-scss-module__DsYWya__search_web_thumbnail__fallback_link",
  "search_web_thumbnail__image": "SearchWebThumbnail-module-scss-module__DsYWya__search_web_thumbnail__image",
  "search_web_thumbnail__link": "SearchWebThumbnail-module-scss-module__DsYWya__search_web_thumbnail__link",
  "search_web_thumbnail__title": "SearchWebThumbnail-module-scss-module__DsYWya__search_web_thumbnail__title",
  "video_detail_thumbnail": "SearchWebThumbnail-module-scss-module__DsYWya__video_detail_thumbnail",
});
